import React, { useCallback, useState, useEffect, useRef } from 'react';
import style from './InspectionTotalDetail.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import InspectionGraphBox from '../../../../../components/box/InspectionGraphBox';

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import ToastPopup from '../../../../../components/comm/ToastPopup';

const PAGE_SIZE = 30;

const InspectionTotalDetail = () => {

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    
    const [subType, setSubType] = React.useState("detail");
    const [open, setOpen] = useState(false);
    const [mediInfo, setMediInfo] = useState();
    const [clnicExamRsltInfo, setClnicExamRsltInfo] = useState({});
    const [clnicExamRsltList, setClnicExamRsltList] = useState([]);
    const [targetExamRsltList, setTargetExamRsltList] = useState({
        title : "",
        data : [],
        range : []
    }); //주요 타겟 검사 결과

    const { hsptlCd = "", patntId = "", deptCd = "", treatYmd = "", rcptNo = "" } = location.state || {};

    const [pageNo, setPageNo] = useState(1);
    const [hasNext, setHasNext] = useState(true);

    const observerRef = useRef(null);
    const scrollObserver = useRef(null);
    const isFirstApiCalled = useRef(false);


    useEffect(() => {
        getClnicInfo();
        getExamRsltDetailList(1);
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    const getClnicInfo = useCallback(async () => {

        const url = "/mypage/retrieveTotalExamRsltDetailInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            hsptlCd : hsptlCd, 
            patntId : patntId,
            deptCd : deptCd,
            treatYmd : treatYmd,
            rcptNo  : rcptNo
        }

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                setMediInfo({...mediInfo});
                setClnicExamRsltInfo(mediInfo.examRsltInfo);
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            setHasNext(false);
            console.error("검사 기본정보 호출 중 오류  : ", err);
        })

    }, []);

    const getExamRsltDetailList = useCallback(async (pageNo) => {

        const url = "/mypage/retrieveTotalExamRsltDetailList";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            hsptlCd : hsptlCd, 
            patntId : patntId,
            deptCd : deptCd,
            treatYmd : treatYmd,
            rcptNo  : rcptNo,
            pageNo: pageNo, 
            pageSize: PAGE_SIZE
        }

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
            noLoading : true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setClnicExamRsltList(prev => [...prev, ...res.data.result.examRsltList]);
                if (!res.data.result.hasNext) setHasNext(false);
            } else {
                setHasNext(false);
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            setHasNext(false);
            console.error("검사 결과 목록 정보 호출 중 오류  : ", err);
        })

    }, []);



    // 그래프에 보여줄 데이터 조회
    const retrieveTargetExamRsltList = useCallback(async (title, range, hsptlCd, deptCd, prscrptnTestCd) => {
        const url = "/mypage/retrieveTargetExamRsltList";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
        }

        await axiosApi.post(url, {hsptlCd : hsptlCd, deptCd:deptCd, prscrptnTestCd : prscrptnTestCd}, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setTargetExamRsltList((prev) => ({ ...prev, title: title, range: range, data:res.data.result.targetExamRsltList }));
                handleClickOpenGraph();
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("타겟 주요검사 결과과 호출 중 오류  : ", err);
        })

    }, []);

    //그래프 오픈
    const handleClickOpenGraph = () => {
        setOpen(true);
    }


    const [abnormalDataSwitch, setAbnormalDataSwitch] = useState(false)
    const handleSwitchChange = (event) => {
        const checked = event.target.checked;
        setAbnormalDataSwitch(checked);
    };


    // ✅ pageNo 변경 시 (2 이상) 호출
    useEffect(() => {
        if (pageNo > 1 && hasNext) {
        getExamRsltDetailList(pageNo);
        }
    }, [pageNo]);

    // ✅ observer는 데이터가 렌더링된 이후에만 등록
    useEffect(() => {
        if (!hasNext || clnicExamRsltList.length === 0) return;

        // 기존 observer 제거
        if (scrollObserver.current && observerRef.current) {
        scrollObserver.current.unobserve(observerRef.current);
        }

        scrollObserver.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
            setPageNo(prev => prev + 1);
        }
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        });

        if (observerRef.current) {
        scrollObserver.current.observe(observerRef.current);
        }

        return () => {
        if (scrollObserver.current && observerRef.current) {
            scrollObserver.current.unobserve(observerRef.current);
        }
        };
    }, [clnicExamRsltList.length, hasNext]);

    return (
        <>
            <HeadSub title="검사 상세"/>
            
            <div id="sub-content">     
                <div className='inner-wrap' data-bg-color="white" data-pad="normal">
                    
                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>기본정보</h2>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li>
                                        <p>검사일자</p>
                                        <span>{clnicExamRsltInfo.treatYmd}</span>
                                    </li>
                                    <li>
                                        <p>진료과</p>
                                        <span>{clnicExamRsltInfo.clnicDeptNms}</span>
                                    </li>
                                    <li>
                                        <p>의료진</p>
                                        <span>{clnicExamRsltInfo.doctrNms}</span>
                                    </li>
                                    <li>
                                        <p>검사 건수</p>
                                        <span>{clnicExamRsltInfo.prscrptnTestCtgrCnt}건</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>검사 정보</h2>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inspection-inform"]}>
                                <ul>
                                    {
                                        (() => {
                                            const testCategories = clnicExamRsltInfo.prscrptnTestCtgrNm || '';
                                            const testCategoryArray = testCategories.split(',').map(item => item.trim());
                                            return testCategoryArray.map((item, index) => (
                                                <li key={index}>
                                                    <span>{item}</span> {/* 여기서 item 값을 실제로 출력 */}
                                                </li>
                                            ));
                                        })()
                                    }                                    
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>검사 결과</h2>
                            <Box sx={{ display: "flex" }} className={style["swich-btn-btn"]}>
                                <Box className="mask-box">
                                    <Box className="mask" style={{ transform: `translateX(${subType === "detail" ? 0 : "var(--sp-wid-86)"})`}}/>
                                    <Button
                                        disableRipple
                                        variant="text"
                                        sx={{ color: subType === "detail" ? "#ffffff" : "#A2A6AC"}}
                                        onClick={() => setSubType("detail")}
                                        className={subType === "detail" ? `${style.active}` : null}
                                    >
                                        자세히 보기
                                    </Button>
                                    <Button
                                        disableRipple
                                        variant="text"
                                        sx={{ color: subType === "simply" ? "#ffffff" : "#A2A6AC"}}
                                        onClick={() => setSubType("simply")}
                                        className={subType === "simply" ? `${style.active}` : null}
                                        >
                                        간략히 보기
                                    </Button>
                                </Box>
                            </Box>
                        </div>
                        
                        <div className="swich-btn m-t-08">
                            <FormControlLabel control={<Switch size="small"/>} label="이상치만 보기" onChange={handleSwitchChange} />
                        </div>
                        
                    </div>
                </div>


                <div className='inner-wrap' data-pad="normal">


                {subType === "detail" ? (
                    // 자세히 보기 

                    <div className={style["detail-list-box"]} data-type="a">
                        <ul> 
                            {

                                clnicExamRsltList.filter((item, index) => {
                                    // 체크되었을 때는 isInRef === '0'인 것만
                                    if (abnormalDataSwitch) return item.isInRef === '0';
                                        return true;
                                    }).map((item, index) => {
                                    return (
                                        <li key={'exam_' + index}>
                                            <div className={style["list-box"]}>
                                                <div className={style["top-head"]}>
                                                    {item.isInRef === '-99' ? <span data-status=''></span> : item.isInRef === '0' ? <span data-status='strange'>이상</span>  : <span data-status="normal">정상</span>}
                                                    {/* <span data-status="normal">정상</span> */}
                                                    <div className={style['btns-box']}>
                                                        <button className={style['graph-more-btn']} onClick={() => {
                                                            retrieveTargetExamRsltList(item.testKorNm, [item.refMin, item.refMax], item.hsptlCd, item.deptCd, item.prscrptnTestCd)
                                                        }}></button>    
                                                    </div>

                                                </div>
                                                <div className={style["head"]}>
                                                    <p>{item.testKorNm} <span>{item.testEngNm}</span></p>
                                                </div>
                                                <div className={style["value-box"]}>
                                                    {/* <strong>0.67mg/dl</strong> */}
                                                    <strong>{item.prscrptnTestRsltVal}{item.unit}</strong>
                                                    {/* <p className={style['compar-value']} data-status="up">(<span>0.12</span>)</p>   */}
                                                    {/* <p className={style['compar-value']} data-status="down">(<span>0.12</span>)</p>   */}
                                                    <p className={style['compar-value']} data-status={item.diffVal === 0 || !item.diffVal ? 'same' : item.diffVal > 0 ? 'up' : 'down'}>
                                                        (<span>{item.diffVal !== 0 ? item.diffVal : ""}</span>)
                                                    </p> 
                                                </div>
                                                <p className={style["details-txt"]}>
                                                    {/* <span>급성 및 만성 신질환의 진단 및 치료 효과 모니터링을 위한 검사</span> */}
                                                    <span>{item.testKorDesc}</span>
                                                </p>
                                            </div>
                                        </li>

                                    )
                                })
                            }
                        </ul>   
                    </div>
                ):(
                    //간략히 보기
                    <div className={style["detail-list-box"]} data-type="b">
                        <ul> 
                            {
                                clnicExamRsltList.filter((item,index) => {
                                    // 체크되었을 때는 isInRef === '0'인 것만
                                    if (abnormalDataSwitch) return item.isInRef === '0';
                                        return true;
                                    }).map((item, index) => {
                                    return (
                                        <li>
                                            <div className ={style["list-box"]}>

                                                <div className={style["mid-box"]}>
                                                    <p>{item.testKorNm} <span>{item.testEngNm}</span></p>
                                                    <div className={style["value-box"]}>
                                                            <p>결과 <span>{item.prscrptnTestRsltVal}</span></p>
                                                            <p>참고치 <span>{item.refVal}</span></p>
                                                    </div>
                                                </div>

                                                <div className={style["right-box"]}>
                                                    {/* <span data-status="strange">이상</span> */}
                                                    {item.isInRef === '-99' ? <span data-status=''></span> : item.isInRef === '0' ? <span data-status='strange'>이상</span>  : <span data-status="normal">정상</span>}
                                                    <button className={style['graph-more-btn']} onClick={() => {
                                                        retrieveTargetExamRsltList(item.testKorNm, [item.refMin, item.refMax], item.hsptlCd, item.deptCd, item.prscrptnTestCd)
                                                    }}></button>
                                                </div>
                                                
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>   
                    </div>
                )}
                <div ref={observerRef} style={{ height: '1px' }} />
                </div>
                <BottomSheet

                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지

                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                         >
                            <InspectionGraphBox
                                    onClose={onDismiss}
                                    title={targetExamRsltList.title}
                                    data={targetExamRsltList.data}
                                    range={targetExamRsltList.range}
                                />
                </BottomSheet>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};
  
export default InspectionTotalDetail;
